import React, { useEffect, useRef, useState } from 'react';
import { add_serial, delete_projects_permission, delete_projects_relation, get_brevo_folders, get_brevo_lists, get_contractor_location, get_location_devices, get_project_permissions, get_project_serials, get_project_updt_status, insert_projects_permission, request_brevo_csv, update_project, validate_procces} from '../../../utils/services';
import {  useNavigate, useSearchParams } from 'react-router-dom';
import md5 from 'md5';

function Contractor_admin  ({usr_id, permission}) {

  const token = localStorage.getItem("token");
  const [searchParams] = useSearchParams();
  const idToken = searchParams.get("id");
  const navigate = useNavigate();

  const [selectedUbicacionId, setSelectedUbicacionId] = useState(null);

  const handleRowClick = (ubic) => {
    setSelectedUbicacionId(ubic.id);
    handleClickUbicacion(ubic);
    loadLocationDevices(ubic.id);
  };




  useEffect(() => {
    if (idToken !== null) {
        refreshLocations(idToken);
    }
    
  }, [idToken]); 
  // Estado para manejar los valores de cada lista
  const [ubicaciones, setUbicaciones] = useState([
  ]);

  const [dispositivos, setDispositivos] = useState([

  ]);

  const [estudiantes, setEstudiantes] = useState([
    { id: 1, nombre: 'Juan Manuel Lopera' },
    { id: 2, nombre: 'Valeria Salazar' },
    { id: 3, nombre: 'Fabian Vargas' },
  ]);

  const refreshLocations = (contractorToken) =>{
        async function fetchLocations(contractorToken) {

                const membersList = await get_contractor_location(token, contractorToken);
                if (membersList==="INVALID"){
                  navigate("/");
                }else{
                  const members = membersList.map((element, index) => {
                    return {id:element.id,city:element.city , name: element.name, name: element.name,  lat_long:element.lat_long, index: index };
                  });

                  setUbicaciones(members);
                          
              }
              }

        fetchLocations(contractorToken);

  }


  const loadLocationDevices = (locationId) =>{
    async function fetchDevices(locationId) {

            const membersList = await get_location_devices(token, locationId);
            if (membersList==="INVALID"){
              navigate("/");
            }else{
              const members = membersList.map((element, index) => {
                return {id:element.id,tomi_serial:element.tomi_serial , manager_id: element.manager_id, index: index };
              });

              setDispositivos(members);
                      
          }
          }

      fetchDevices(locationId);

}

  // -----------------------------
  // Manejo de eventos: Ubicaciones
  // -----------------------------
  const handleClickUbicacion = (ubicacion) => {
    // Aquí la lógica de lo que sucedería cuando se hace clic en una ubicación
  };

  const handleSearchUbicacion = (event) => {
    // Aquí podrías filtrar la lista de ubicaciones según lo que se escriba
    // Lógica de filtrado o actualización de estado
  };

  const handleDeleteUbicacion = (idUbicacion) => {
    // Aquí la lógica para eliminar la ubicación
  };

  // -----------------------------
  // Manejo de eventos: Dispositivos
  // -----------------------------
  const handleClickDispositivo = (dispositivo) => {
    // Lógica cuando se hace clic en un dispositivo
  };

  const handleSearchDispositivo = (event) => {
    // Aquí podrías filtrar la lista de dispositivos
    // Lógica de filtrado o actualización de estado
  };

  const handleDeleteDispositivo = (idDispositivo) => {
    // Aquí la lógica para eliminar el dispositivo
  };

  // -----------------------------
  // Manejo de eventos: Estudiantes
  // -----------------------------
  const handleClickEstudiante = (estudiante) => {
    // Lógica cuando se hace clic en un estudiante
  };

  const handleSearchEstudiante = (event) => {
    // Aquí podrías filtrar la lista de estudiantes
    // Lógica de filtrado o actualización de estado
  };

  const handleDeleteEstudiante = (idEstudiante) => {
    // Aquí la lógica para eliminar un estudiante
  };

  // -----------------------------
  // Render principal del componente
  // -----------------------------
  return (
    <div className="alcaldia-medellin-container">
  {/* Encabezado */}
  <header>
    <h1>Cliente: Alcaldía de Medellín</h1>
    <nav>
      <ul>
        <li>Retención Escolar</li>
        <li>Router</li>
        <li>Monitor Ruido</li>
        <li>Pizarra Digital</li>
      </ul>
    </nav>
  </header>

  {/* Contenedor de columnas */}
  <div className="paneles-contenedor">
    {/* Panel: Ubicaciones */}
  {/* Panel: Ubicación */}
<div className="panel-ubicaciones">
  <h3>Ubicación</h3>
  <input
    type="text"
    placeholder="Buscar ubicación..."
    onChange={handleSearchUbicacion}
  />
  <table>
    <thead>
      <tr>
        <th>Nombre</th>
        <th>Acción</th>
      </tr>
    </thead>
    <tbody>
      {ubicaciones.map((ubic) => (
        <tr
          key={ubic.id}
          className={selectedUbicacionId === ubic.id ? "selected" : ""}
          onClick={() => handleRowClick(ubic)}
        >
          <td>{ubic.name}</td>
          <td>
            <span
              className="delete-icon"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteUbicacion(ubic.id);
              }}
            >
              X
            </span>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  <button onClick={() => {}}>+</button>
</div>

{/* Panel: Dispositivos */}
<div className="panel-dispositivos">
  <h3>Dispositivos</h3>
  <input
    type="text"
    placeholder="Buscar dispositivo..."
    onChange={handleSearchDispositivo}
  />
  <table>
    <thead>
      <tr>
        <th>Serial</th>
        <th>Acción</th>
      </tr>
    </thead>
    <tbody>
      {dispositivos.map((disp) => (
        <tr
          key={disp.id}
          onClick={() => handleClickDispositivo(disp)}
        >
          <td>{disp.tomi_serial}</td>
          <td>
            <span
              className="delete-icon"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteDispositivo(disp.id);
              }}
            >
              X
            </span>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  <button onClick={() => {}}>+</button>
</div>

{/* Panel: Grupo de estudiantes */}
<div className="panel-estudiantes">
  <h3>Grupo de estudiantes</h3>
  <input
    type="text"
    placeholder="Buscar estudiante..."
    onChange={handleSearchEstudiante}
  />
  <table>
    <thead>
      <tr>
        <th>Nombre</th>
        <th>Acción</th>
      </tr>
    </thead>
    <tbody>
      {estudiantes.map((est) => (
        <tr
          key={est.id}
          onClick={() => handleClickEstudiante(est)}
        >
          <td>{est.nombre}</td>
          <td>
            <span
              className="delete-icon"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteEstudiante(est.id);
              }}
            >
              X
            </span>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  <button onClick={() => {}}>+</button>
</div>
</div>
</div>

  );
};

export default Contractor_admin;
